import React, { useEffect, useState } from "react";
import { useI18n, ROLE_LABELS } from "../../i18n";
import { api } from "../../lib/api";
import { StatCard } from "../../components/app/widgets";

export default function Workload() {
  const { t, pick } = useI18n();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/workload").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="text-muted-foreground">{t("loading")}</div>;

  return (
    <div className="space-y-6 gc-fade-up">
      <h1 className="font-display text-2xl font-bold text-[hsl(217_63%_15%)]">{t("nav_workload")}</h1>
      <div className="grid sm:grid-cols-3 gap-4">
        <StatCard testid="wl-spec" label={t("specialist_queue")} value={d.specialist_queue} accent="hsl(199 89% 48%)" />
        <StatCard testid="wl-sup" label={t("supervisor_queue")} value={d.supervisor_queue} accent="hsl(217 63% 15%)" />
        <StatCard testid="wl-qc" label={t("quality_queue")} value={d.quality_queue} accent="hsl(262 60% 55%)" />
      </div>
      <div className="rounded-2xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/60 text-muted-foreground text-xs"><tr>
            <th className="text-start px-4 py-3 font-medium">{t("name")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("role")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("assigned_cases")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("pending_cases")}</th>
            <th className="text-start px-4 py-3 font-medium">{t("hours_worked")}</th>
          </tr></thead>
          <tbody>
            {d.staff.map((s) => (
              <tr key={s.id} className="border-t border-border">
                <td className="px-4 py-3 font-medium">{s.name}</td>
                <td className="px-4 py-3 text-muted-foreground">{pick(ROLE_LABELS[s.role])}</td>
                <td className="px-4 py-3 font-mono">{s.assigned}</td>
                <td className="px-4 py-3 font-mono">{s.pending}</td>
                <td className="px-4 py-3 font-mono font-bold text-[hsl(158_64%_28%)]">{s.hours} {t("hours")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
